import { Box, ButtonGroup, IconButton, Tooltip, Zoom } from "@material-ui/core";
import { Comment, Info, Pageview } from "@material-ui/icons";

import * as React from "react";
import ShopReportPdf from "./ShopReportPdf";
import { useAccessControl } from "@airborne/react-admin";

export const DataGridActions = (props: any) => {
  const remarkOnClick = e => {
    e.stopPropagation();
    props?.remarkAddClick?.(props?.record);
  };
  const viewerOnClick = e => {
    e.stopPropagation();
    props?.handlePDFViewer?.(props?.record);
  };

  const fieldsInClick = e => {
    e.stopPropagation();
    props?.handleShopReportFields?.(props?.record);
  };

  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl("vwshopreports");

  const RemarkButton = () => {
    return (
      <IconButton style={{ width: 40 }} onClick={remarkOnClick}>
        <Tooltip TransitionComponent={Zoom} title="Add Comment">
          <Comment />
        </Tooltip>
      </IconButton>
    );
  };
  const PDFViewerButton = () => {
    return (
      <IconButton style={{ width: 40 }} onClick={viewerOnClick}>
        <Tooltip TransitionComponent={Zoom} title="PDF Viewer">
          <Pageview />
        </Tooltip>
      </IconButton>
    );
  };

  const ShopReportFields = () => {
    return (
      <IconButton style={{ width: 40 }} onClick={fieldsInClick}>
        <Tooltip TransitionComponent={Zoom} title="Details">
          <Info />
        </Tooltip>
      </IconButton>
    );
  };

  return (
    <Box style={{ flex: 1, flexDirection: "row" }}>
      <ButtonGroup variant="text" size="small">
        {canCreate && <RemarkButton />}
        <PDFViewerButton />
        <ShopReportFields />
        <ShopReportPdf {...props} />
      </ButtonGroup>
    </Box>
  );
};
export default DataGridActions;
